export default __webpack_public_path__ + "static/media/S.d2deee57.svg";